export const url = "https://smart-care-backend-topaz.vercel.app";
// export const url = "https://backend-9x8p.smartcareclinic.ae";
